import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFormats'
})

export class SearchFormatsPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    if (pipeModifier != 'FORMAT') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['film_type']) {
          return (
            eachItem['fields']['film_type'].includes(pipeModifier)
          )
        }
      });
    } else {
      return pipeData
    }
  }
}